export default __webpack_public_path__ + "static/media/G0004.e0b14f56.png";